export const CATEGORY_POSTS_PER_PAGE = 6;
export const RELATED_POSTS_PER_PAGE = 6;
export const BLOG_POST_SORT_BY = 'content.body.0.publishDate:desc,published_at:desc,created_at:desc';
